import { Mail, MessageCircle, Phone } from "lucide-react";

export default function Footer() {
    return (
        <footer className="bg-black border-t border-[#1a1a1a]" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-12">
                <div>
                    <img
                        src="/ramsol-logo.jpg"
                        alt="RAMSOL · Soluciones Constructivas"
                        className="h-14 w-auto block rounded-full"
                    />
                    <p className="mt-5 text-white/55 text-sm leading-relaxed max-w-xs">
                        Constructora especializada en obras civiles, mantenimiento industrial e instalaciones de alto rendimiento.
                    </p>
                </div>

                <div>
                    <p className="text-[10px] uppercase tracking-[0.25em] text-white/40">Navegación</p>
                    <ul className="mt-5 space-y-3">
                        {[
                            { l: "Nosotros", h: "/nosotros" },
                            { l: "Servicios", h: "/#servicios" },
                            { l: "Contacto", h: "/#contacto" },
                        ].map((i) => (
                            <li key={i.h}>
                                <a href={i.h} className="text-white/75 hover:text-[#14888F] text-sm transition-colors" data-testid={`footer-link-${i.l.toLowerCase()}`}>
                                    {i.l}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="text-[10px] uppercase tracking-[0.25em] text-white/40">Contacto</p>
                    <ul className="mt-5 space-y-3 text-sm">
                        <li className="flex items-center gap-2 text-white/75">
                            <MessageCircle size={14} className="text-[#14888F]" />
                            <a href="https://wa.me/543704504444" target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-whatsapp">WhatsApp +54 9 370 450-4444</a>
                        </li>
                        <li className="flex items-center gap-2 text-white/75">
                            <Phone size={14} className="text-[#14888F]" />
                            <a href="tel:+543704504444" className="hover:text-white" data-testid="footer-phone">+54 9 370 450-4444</a>
                        </li>
                        <li className="flex items-center gap-2 text-white/75">
                            <Mail size={14} className="text-[#14888F]" />
                            <a href="mailto:ramirez.arq1@gmail.com" className="hover:text-white break-all" data-testid="footer-email">ramirez.arq1@gmail.com</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-[#1a1a1a]">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/45">
                    <p>© {new Date().getFullYear()} RAMSOL · Todos los derechos reservados.</p>
                    <p className="uppercase tracking-[0.25em]">Soluciones Constructivas</p>
                </div>
            </div>
        </footer>
    );
}
